<template>
  <article class="flex flex-col">
    <h1
      class="mb-[24px] text-center font-roboto text-[32px] font-medium leading-6 text-specialprojectsection"
    >
      Биографии
    </h1>
    <CommonComplexFiltering
      v-if="false"
      :key="isAnyFiltersActive"
      class="mb-[20px]"
      :rubrics-list="rubrics?.data?.value"
      :sort-options="sortOptions"
      :centuries-list="centuries"
      :filters-active="filters"
      is-centuries-disabled
      is-not-array-century
      is-biography
    />
    <div class="-m-2.5 flex flex-wrap">
      <MainPageCardsReworkedBaseCard
        v-for="biography in biographies?.data?.value?.data"
        :key="biography.id"
        animated-announce
        :aspect="{ w: 1, h: 1 }"
        class="w-full max-w-[100%] p-2.5 sm:max-w-[50%] xl:max-w-[33.33333%]"
        :data="biography"
        disable-author
      />
    </div>
    <BaseThePagination :entity="biographies" />

    <!-- <div class="mt-[64px] flex justify-center">
      <BaseTheButtonNew
        v-if="biographies.hasNextPage.value"
        text="Показать еще"
        @click="biographies.fetchNextPage()"
      />
    </div> -->
  </article>
</template>

<script setup>
const route = useRoute();
const router = useRouter();

const filters = computed(() => {
  return {
    century: route.query?.century,
    sort_by: route.query?.sort_by,
    category: route.query?.category,
  };
});

const page = computed(() => Number(route.query?.page) || 1);
const { biographies, resetPage } = useBiography({ filters, per_page: 9, page });
const { rubrics } = useBiographiesCategories();

const isAnyFiltersActive = computed(() => Object.values(route.query).length);

watch(filters, (newValue, prevValue) => {
  if (JSON.stringify(newValue) === JSON.stringify(prevValue)) return;
  router.push({ query: { ...route.query, page: undefined } });
  resetPage(prevValue);
});

const centuries = ref([]);
centuries.value = new Array(20);
centuries.value.fill('');

const getRomanDigit = (num) => {
  const base = {
    M: 1000,
    CM: 900,
    D: 500,
    CD: 400,
    C: 100,
    XC: 90,
    L: 50,
    XL: 40,
    X: 10,
    IX: 9,
    V: 5,
    IV: 4,
    I: 1,
  };

  let res = '';
  for (const i in base) {
    while (num >= base[i]) {
      res += i;
      num -= base[i];
    }
  }

  return res;
};
centuries.value = centuries.value
  .map((el, index) => {
    const century = +index + 1;
    return {
      id: century,
      label: getRomanDigit(century),
    };
  })
  .splice(7, centuries.value.length);

const sortOptions = [
  { id: 0, label: 'Свежие', value: '', icon: 'timer' },
  {
    id: 1,
    label: 'Обсуждаемые',
    value: 'comments',
    icon: 'chat-circle',
  },
  { id: 2, label: 'Популярные', value: 'views', icon: 'eye' },
];

const { canonicalUrl, title } = useSeoHelper();

useHead(() => ({
  title: title(
    'Биографии известных личностей РФ | Читать на Федеральном портале Истории России',
  ),
  meta: [
    {
      hid: 'description',
      name: 'description',
      content:
        'Биографии великих личностей Российской Федерации. Мы знаем правду как о ныне живуших, так и уже умерших выдающихся людей России. Российское военно-историческое общество.',
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: canonicalUrl.value,
    },
  ],
}));
</script>

<style lang="scss"></style>
